import { ConversationConfig } from '@/types_cp/agent';
import { SilverTigerAgentChatConfig } from '@/types_cp/agent/chat-config';
import { UserSettings } from '@/types_cp/user/settings';
import { QueryRewriteSystemAgent, SystemAgentItem, UserSystemAgentConfig } from '@/types_cp/user/settings/system-agent';
import { DEFAULT_COMMON_SETTINGS } from './common';
import { DEFAULT_HOTKEY_CONFIG } from './hotkey';
import { DEFAULT_SYNC_CONFIG } from './sync';

export const COOKIE_CACHE_DAYS = 30;

// Default model and provider
export const DEFAULT_MODEL = 'gpt-4.1-mini';
export const DEFAULT_PROVIDER = 'openai';

// Default agent chat configuration
export const DEFAULT_AGENT_CHAT_CONFIG: SilverTigerAgentChatConfig = {
  autoCreateTopicThreshold: 2,
  displayMode: 'chat',
  enableAutoCreateTopic: true,
  historyCount: 4,
};

// Default agent configuration
export const DEFAULT_AGENT_CONFIG: ConversationConfig = {
  chatConfig: DEFAULT_AGENT_CHAT_CONFIG,
  params: {
    frequency_penalty: 0,
    presence_penalty: 0,
    temperature: 0.6,
    top_p: 1,
  },
  provider: DEFAULT_PROVIDER,
  systemRole: '',
};

// Default system agent item
export const DEFAULT_SYSTEM_AGENT_ITEM: SystemAgentItem = {
  model: DEFAULT_MODEL,
  provider: DEFAULT_PROVIDER,
};

// Default query rewrite system agent item
export const DEFAULT_QUERY_REWRITE_SYSTEM_AGENT_ITEM: QueryRewriteSystemAgent = {
  enabled: true,
  model: DEFAULT_MODEL,
  provider: DEFAULT_PROVIDER,
};

// Default system agent configuration
export const DEFAULT_SYSTEM_AGENT_CONFIG: UserSystemAgentConfig = {
  agentMeta: DEFAULT_SYSTEM_AGENT_ITEM,
  generationTopic: DEFAULT_SYSTEM_AGENT_ITEM,
  historyCompress: DEFAULT_SYSTEM_AGENT_ITEM,
  queryRewrite: DEFAULT_QUERY_REWRITE_SYSTEM_AGENT_ITEM,
  thread: DEFAULT_SYSTEM_AGENT_ITEM,
  topic: DEFAULT_SYSTEM_AGENT_ITEM,
  translation: DEFAULT_SYSTEM_AGENT_ITEM,
};

export * from './hotkey';
export * from './tool';

export const DEFAULT_SETTINGS: UserSettings = {
  general: DEFAULT_COMMON_SETTINGS,
  hotkey: DEFAULT_HOTKEY_CONFIG,
  keyVaults: {},
  sync: DEFAULT_SYNC_CONFIG,
};
